import React, { createContext, useContext, useState, useCallback } from "react";
import {
  getIndicadoresByAsignaturaYPeriodo,
  getIndicadoresByPeriodoYSalon,
  createIndicador,
  updateIndicador,
  deleteIndicador,
} from "../services/indicadoresService";

const IndicadoresContext = createContext();

export const useIndicadores = () => useContext(IndicadoresContext);

export const IndicadoresProvider = ({ children }) => {
  const [indicadores, setIndicadores] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchIndicadores = useCallback(async (asignaturaId, periodoId) => {
    setLoading(true);
    try {
      const data = await getIndicadoresByAsignaturaYPeriodo(asignaturaId, periodoId);
      setIndicadores(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchIndicadoresBySalonYPeriodo = useCallback(async (periodoId, salonId) => {
    setLoading(true);
    try {
      const data = await getIndicadoresByPeriodoYSalon(periodoId, salonId);
      setIndicadores(data);
      return data;
    } catch (error) {
      return [];
    } finally {
      setLoading(false);
    }
  }, []);
  

  const createIndicadorData = async (nuevoIndicador) => {
    const data = await createIndicador(nuevoIndicador);
    return data;
  };

  const updateIndicadorData = async (id, descripcion) => {
    const data = await updateIndicador(id, descripcion);
    return data;
  };

  const deleteIndicadorData = async (periodoId, salonId) => {
    try {
      const response = await deleteIndicador(periodoId, salonId);
      setIndicadores([]); // Vaciar lista local
      return response; // <- retornar mensaje
    } catch (error) {
      throw error; // para que el frontend pueda mostrar una notificación si quieres
    }
  };
  
  return (
    <IndicadoresContext.Provider
      value={{
        indicadores,
        loading,
        fetchIndicadores,
        fetchIndicadoresBySalonYPeriodo,
        createIndicadorData,
        updateIndicadorData,
        deleteIndicadorData,
      }}
    >
      {children}
    </IndicadoresContext.Provider>
  );
};
